import http from '../../../services/api'
import type { APIPaginatedResponse, Filters, Pagination } from '../../../services/types'
import { getExpenseListParamString } from './expenseListQueryParams'
import type { ExpenseItemApi, ExpenseItemCreatePayload, ExpenseItemUpdatePayload } from '../types'

const apiPath = import.meta.env.VITE_API_PATH
const basePath = `${apiPath}expense/items`

type ExpenseItemSingleResponse = { data: ExpenseItemApi }

async function getExpenseItems(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  const paramString = getExpenseListParamString(filters, pagination)
  return await http.get<APIPaginatedResponse<ExpenseItemApi>>(basePath + paramString)
}

async function createExpenseItem(payload: ExpenseItemCreatePayload) {
  return await http.post<ExpenseItemSingleResponse>(basePath, payload)
}

async function updateExpenseItem(uuid: string, payload: ExpenseItemUpdatePayload) {
  return await http.put<ExpenseItemSingleResponse>(`${basePath}/${uuid}`, payload)
}

async function deleteExpenseItem(uuid: string) {
  return await http.delete<undefined>(`${basePath}/${uuid}`)
}

const expenseItemsService = {
  getExpenseItems,
  createExpenseItem,
  updateExpenseItem,
  deleteExpenseItem,
}

export default expenseItemsService
